import { FieldValues, RegisterOptions } from 'react-hook-form';

import { debounce, CancelPromiseHandler, makeCancellablePromise } from '@gem/utils';

import { userSettingsModel } from 'APP/model/model';

const NICKNAME_REGEXP = /^[a-zA-Z0-9._]+$/;
const TRIM_SYMBOL_REGEXP = /^[._ ]+|[._ ]+$/g;

const isAvailableNickName = debounce(
  async (value: string, callback: (isAvailable: boolean) => void) => {
    try {
      const { isAvailable } = await userSettingsModel.validateNickName(value);

      if (!isAvailable) {
        callback(false);
      }
    } catch {
      callback(false);
    }
    callback(true);
  },
  1000
);

let cancelLoadMore: CancelPromiseHandler | null = null;

export function nickNameValidation<TFieldValues extends FieldValues = FieldValues>(
  symbolsMessage: string,
  exisitsMessage: string
): RegisterOptions<TFieldValues> {
  return {
    async validate(value: string): Promise<string | boolean> {
      if (cancelLoadMore) {
        cancelLoadMore();
        cancelLoadMore = null;
      }

      if (!NICKNAME_REGEXP.test(value)) {
        return symbolsMessage;
      }

      if (value !== value.replace(TRIM_SYMBOL_REGEXP, '')) {
        return symbolsMessage;
      }

      const { promise, cancel } = makeCancellablePromise<boolean | string>(
        new Promise((resolve) => {
          isAvailableNickName(value, (isAvailable) => {
            resolve(isAvailable || exisitsMessage);
          });
        })
      );

      cancelLoadMore = cancel;

      return promise;
    },
  };
}
